var _feGaussianBlur;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShapeCircleHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 31.749998 31.75",
    id: "svg19093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs19087"
  }, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter23540",
    x: -0.096000001,
    width: 1.192,
    y: -0.096000001,
    height: 1.192
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.84666664,
    id: "feGaussianBlur23542"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-265.24999)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 0.7,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.21950617,
      strokeOpacity: 1,
      filter: "url(#filter23540)"
    },
    id: "rect4518-85-4-79-8",
    width: 21.166666,
    height: 21.166666,
    x: 3.5527137e-15,
    y: 275.83331,
    rx: 10.583333,
    ry: 10.583333,
    transform: "matrix(1.2583892,0,0,1.2583892,2.5570496,-79.29864)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShapeCircleHighlight);
export default __webpack_public_path__ + "static/media/icon-shape-circle-highlight.a30e531ab3168c61e40e47f4bbc23ed5.svg";
export { ForwardRef as ReactComponent };